// src/components/common/aia/tours/employeeTours.js
export const employeeTours = [
    {
        id: 'employee-welcome-tour',
        title: 'Welcome Tour',
        role: 'employee',
        autoStart: true,
        steps: [
            {
                target: null,
                title: 'Welcome to OakHR! 👋',
                content: "Hi! I'm your AI assistant, and I'm here to help you get started with OakHR. Let me show you around your Employee Portal so you can make the most of all the features available to you.",
                position: 'bottom'
            },
            {
                target: '.tour-employee-dashboard',
                title: 'Your Personal Dashboard',
                content: 'This is your dashboard! Here you\'ll see a quick overview of everything that matters to you - your attendance stats, leave balance, upcoming holidays, pending approvals, and recent announcements. Everything at a glance!',
                position: 'right'
            },
            {
                target: '.tour-employee-attendance',
                title: 'Mark Your Attendance',
                content: 'Stay on top of your attendance! Here you can mark your daily attendance, view your attendance history, check your regularized requests, and see your monthly attendance summary. Remember to mark your attendance daily!',
                position: 'right'
            },
            {
                target: '.tour-employee-leaves',
                title: 'Manage Your Leaves',
                content: 'Need time off? You can apply for leave requests here, check your leave balance, view your leave history, and see the status of your pending requests. Your manager will be notified automatically!',
                position: 'right'
            },
            {
                target: '.tour-employee-payroll',
                title: 'View Your Payslips',
                content: 'Access all your payslips here! You can view, download, or print your monthly payslips. They\'re organized by month and payroll run for easy access.',
                position: 'right'
            },
            {
                target: null,
                title: 'You\'re All Set! 🎉',
                content: "You've completed the quick tour! Feel free to explore all the features, and don't hesitate to reach out if you have any questions. Just click on my avatar anytime you need help. Welcome to the OakHR family!",
                position: 'bottom'
            }
        ]
    },
    {
        id: 'employee-onboarding-tour',
        title: 'Onboarding Guide',
        role: 'employee',
        autoStart: false,
        steps: [
            {
                target: '.tour-employee-onboarding',
                title: 'Complete Your Onboarding',
                content: 'Welcome aboard! Let\'s get your onboarding started. Click here to access your onboarding checklist, upload required documents, and track your progress.',
                position: 'right'
            },
            {
                target: null,
                title: 'Onboarding Tips',
                content: 'Tip: Complete all items in your onboarding checklist as soon as possible. This helps HR process your profile faster and ensures you don\'t miss any important steps!',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'employee-profile-tour',
        title: 'Profile & Settings',
        role: 'employee',
        autoStart: false,
        steps: [
            {
                target: '.tour-employee-profile',
                title: 'Your Profile',
                content: 'Keep your profile up to date! Here you can update your personal information, contact details, emergency contacts, and profile picture.',
                position: 'right'
            },
            {
                target: '.tour-employee-goals',
                title: 'Your Goals',
                content: 'Track your goals and OKRs here. Set objectives, measure progress, and stay aligned with team priorities.',
                position: 'right'
            }
        ]
    },
    {
        id: 'employee-dashboard-exploration',
        title: 'Dashboard Deep Dive',
        role: 'employee',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Dashboard Exploration 🗺️',
                content: "Welcome to your personal dashboard! This is your command center where you can see everything important at a glance. Let me walk you through each section.",
                position: 'bottom'
            },
            {
                target: '[data-tour="dashboard-welcome"]',
                title: 'Welcome Message',
                content: 'See your name highlighted in blue? This personalized welcome reminds you that this is YOUR space. Everything here is tailored to help you manage your work life efficiently.',
                position: 'bottom'
            },
            {
                target: '[data-tour="dashboard-clock"]',
                title: 'Date & Clock',
                content: 'Stay on top of time! Here you see the current date, day of the week, and a live digital clock. Click the clock to toggle between 12-hour and 24-hour formats.',
                position: 'left'
            },
            {
                target: '[data-tour="dashboard-attendance-stats"]',
                title: 'Attendance Overview',
                content: 'Quick view of your attendance! This shows your present days versus total working days in the current month. Keeping good attendance helps build a strong work ethic.',
                position: 'right'
            },
            {
                target: '[data-tour="dashboard-quick-requests"]',
                title: 'Quick Actions',
                content: 'Need to apply for leave or work from home? These buttons give you quick access to the most common actions. No need to navigate away from the dashboard!',
                position: 'right'
            },
            {
                target: '[data-tour="dashboard-quick-actions"]',
                title: 'Check In/Out',
                content: 'Start and end your workday here! The green Check In button marks your arrival, and the red Check Out button records your departure. The timer below shows how long you\'ve been active.',
                position: 'right'
            },
            {
                target: '[data-tour="dashboard-announcements"]',
                title: 'Announcements',
                content: 'Stay in the loop! This section shows the latest company announcements - from policy changes to holiday schedules. High-priority items are marked with "Important" badges.',
                position: 'left'
            },
            {
                target: '[data-tour="dashboard-celebrations"]',
                title: 'Celebration Hub',
                content: 'Never miss a moment! Birthdays, work anniversaries, and other celebrations are shown here. It\'s a great way to stay connected with your workplace community.',
                position: 'left'
            },
            {
                target: '[data-tour="dashboard-tasks"]',
                title: 'Task Management',
                content: 'Your personal and team tasks at a glance! The Personal Tasks widget shows tasks assigned to you, while Team Tasks shows what your team is working on. Stay organized and on top of your deliverables!',
                position: 'left'
            },
            {
                target: '[data-tour="dashboard-my-access"]',
                title: 'My Access',
                content: 'All your HR modules in one place! Click any card to access Task Box, Vibe, Compensation, Attendance, Documents, Performance, Org View, and more. Red badges indicate pending items that need your attention.',
                position: 'top'
            },
            {
                target: null,
                title: 'You\'re a Dashboard Pro! 🌟',
                content: "You now know your dashboard inside out! Remember to check in daily when you arrive, keep an eye on announcements, and don't forget to explore all the great features available to you.",
                position: 'bottom'
            }
        ]
    }
];

export const getEmployeeTour = (tourId) => {
    return employeeTours.find(tour => tour.id === tourId);
};

export const getAllEmployeeTours = () => employeeTours;
